import { getIsTicketing } from '@/utils/helpers'

const normalizeUrl = url => (url ? String(url).replace(/\/$/, '') : '')
const hasVenueRouteParams = routeParams =>
	Boolean(routeParams?.subDomain && routeParams?.venueChainId)

const appendVenueRouteParams = (baseUrl, routeParams) => {
	if (!hasVenueRouteParams(routeParams)) {
		return baseUrl
	}

	return `${baseUrl}/${routeParams.subDomain}/${routeParams.venueChainId}`
}

const isLocalHost = () =>
	typeof window !== 'undefined' &&
	['localhost', '127.0.0.1'].includes(window.location.hostname)

const isLocalCrossDomainEnabled = () =>
	process.env.NODE_ENV !== 'production' &&
	(process.env.VUE_APP_USE_LOCAL_CROSS_DOMAIN === 'true' || isLocalHost())

const getLocalOmOrigin = () =>
	normalizeUrl(process.env.VUE_APP_LOCAL_OM_ORIGIN || 'http://localhost:8080')

const getLocalTicketingOrigin = () =>
	normalizeUrl(
		process.env.VUE_APP_LOCAL_TICKETS_ORIGIN || 'http://localhost:8088'
	)

const isCurrentTicketingDomain = () => {
	if (!isLocalCrossDomainEnabled() || typeof window === 'undefined') {
		return getIsTicketing()
	}

	return normalizeUrl(window.location.origin) === getLocalTicketingOrigin()
}

export const getOnlineMenuBaseUrl = (venueInfo, routeParams = {}) => {
	if (isLocalCrossDomainEnabled()) {
		return appendVenueRouteParams(getLocalOmOrigin(), routeParams)
	}

	return normalizeUrl(venueInfo?.onlineMenuUrl)
}

export const getTicketingBaseUrl = (venueInfo, routeParams = {}) => {
	if (isLocalCrossDomainEnabled()) {
		return appendVenueRouteParams(getLocalTicketingOrigin(), routeParams)
	}

	return normalizeUrl(venueInfo?.ticketsUrl)
}

export const getDomainSwitcherTargetUrl = (venueInfo, routeParams = {}) => {
	const isTicketing = isCurrentTicketingDomain()

	return isTicketing
		? getOnlineMenuBaseUrl(venueInfo, routeParams)
		: getTicketingBaseUrl(venueInfo, routeParams)
}
